export let constant = null;
export function loadConstant(moduleName, moduleConst) {
  if (moduleConst) {
    // 合并静态变量
    if (!constant) {
      // constant = Object.assign({}, moduleConst);
      constant = {};
      constant[moduleName] = moduleConst;
    } else {
      // 检测变量重复
      // checkRouteRepeat(constant, moduleConst, moduleName);
      // 合并到 constant 对象上
      // constant = Object.assign(constant, moduleConst);
      constant[moduleName] = moduleConst;
    }
  }
}
